import { ClipLoader } from 'react-spinners';

const Loader = ({
  loading = false,
  children = null,
  className = '',
  size = 50,
  paddingTop = '10%',
  ...props
}) => {
  return loading ? (
    <div
      data-qa="switch-view-loading"
      style={{ textAlign: '-webkit-center', paddingTop: paddingTop }}
      className={className}
    >
      <ClipLoader
        size={size}
        color="var(--color-background-darker)"
        loading={loading}
        {...props}
      />
    </div>
  ) : (
    <>{children}</>
  );
};

export default Loader;
